module.exports = __webpack_public_path__ + "static/media/TS.d6e5447e.svg";